import React from 'react';
import PropTypes from 'prop-types';
import { Label, Row, Col, Button } from 'reactstrap';
import TextInput from '../controls/textInput';
import { removeItemWithConfirm } from '../classes/handleItemWithConfirm';
import { ResizedUploader as Upload } from '../controls/upload';
import Icon from '../containers/icon';
import Thumbnail from './thumbnail';
const PhotoItem = ({
  className: _className = 'no-class-name',
  marginTop: _marginTop = '0px',
  data: {
    tempPath,
    caption
  },
  includeDivider: _includeDivider = false,
  hasCaption: _hasCaption = true,
  disabled: _disabled = false,
  loading: _loading = false,
  setSaveStatus,
  fluid: _fluid = false,
  onUpload,
  data,
  index,
  onChange,
  onRemove
}) => {
  const handleChange = (name, value, isPending = true) => {
    onChange({
      index,
      name,
      value,
      isPending
    });
  };
  const handleChangeCaption = (_, value) => {
    onChange(index, {
      name: 'caption',
      value
    });
  };
  const handleUpload = onUpload.bind(this, data, index);
  const confirmOnRemoveFields = ['caption', 'path'];
  // handleRemove = () => props.onRemove({ name: 'photo', index: props.index, isPending: true });
  const handleRemove = () => onRemove(index);
  // this calls onRemove IFF either
  //   a) there is no data to confirm removing in the item, or
  //   b) the user says it is okay to remove the all the data.
  const handleRemovePhoto = () => removeItemWithConfirm(data, 'photo', confirmOnRemoveFields, handleRemove);

  // Build the upload dropzone and button
  const uploadProps = {
    loading: _loading,
    onChange: handleChange,
    onUpload: handleUpload,
    setSaveStatus
  };

  // Thumbnail throws a console warning if you try and make a thumbnail with empty source
  const uploadOrImage = tempPath ? /*#__PURE__*/React.createElement(Thumbnail, {
    src: tempPath,
    style: {
      width: '100%',
      marginBottom: '0px'
    }
  }) : /*#__PURE__*/React.createElement(Upload, uploadProps);
  return /*#__PURE__*/React.createElement("section", {
    style: {
      marginTop: _marginTop
    }
  }, /*#__PURE__*/React.createElement(Row, {
    className: _className
  }, /*#__PURE__*/React.createElement(Col, {
    sm: _fluid ? 12 : 9,
    style: {
      marginBottom: '20px'
    },
    className: "t-pi-image"
  }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), uploadOrImage), /*#__PURE__*/React.createElement(Col, {
    sm: _fluid ? 12 : 3
  }, _hasCaption ? /*#__PURE__*/React.createElement(TextInput, {
    type: "textarea",
    label: "Description",
    value: caption || '',
    style: {
      minHeight: '150px'
    },
    onChange: handleChangeCaption,
    className: "t-p-caption"
  }) : undefined, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    disabled: _disabled,
    className: "form-control t-p-remove-photo tqc-control",
    onClick: handleRemovePhoto
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }), " Remove Photo"))), _includeDivider ? /*#__PURE__*/React.createElement("hr", null) : undefined);
};
PhotoItem.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.shape({
    caption: PropTypes.string,
    tempPath: PropTypes.string
  }).isRequired,
  disabled: PropTypes.bool,
  fluid: PropTypes.bool,
  hasCaption: PropTypes.bool,
  includeDivider: PropTypes.bool,
  index: PropTypes.number.isRequired,
  marginTop: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  setSaveStatus: PropTypes.func.isRequired,
  className: PropTypes.string
};
export default PhotoItem;